import React, { Component } from 'react';
import CheckoutSummary from '../../stateless/checkoutsummary/checkoutsummary';
import ContactData from './ContactData/ContactData';
import {Route} from 'react-router-dom';
import classes from './Checkout.module.css';

import NoRecord from '../../assets/images/No Record.png';

import { connect } from 'react-redux';

class Checkout extends Component{
    state={
        shouldShow : true
    }

    componentDidMount(){
        let queryValues = new URLSearchParams(this.props.history.location.search);
        let params = {}
        for (let param of queryValues){
            params[param[0]] = +param[1];
        }
        this.setState({ingredients:params});
    }

    componentDidUpdate(previousProps , previousState){
        if(!previousState.shouldShow)
            this.setState({shouldShow:true});
        return !previousState.shouldShow;
    }

    openForms = () =>{
        this.setState({shouldShow:false});
        this.props.history.replace('/checkout/contactData');
    };

    goBack = () => {
        this.props.history.goBack();
    }

    render(){
        let isIngredientsAvailable = Object.values(this.props.ingredients)
            .reduce((current , sum) => {
                return sum + current;
            } , 0) > 0 ?
            <CheckoutSummary ingredients={this.props.ingredients}
                goBack={this.goBack} openForms={this.openForms} shouldShow={this.state.shouldShow} /> :
            <div style={{
                width: '100%',
                textAlign: 'center',
                margin: '0px auto',
                boxSizing: 'border-box',
                padding: '20px',
                fontFamily: 'cursive'
            }}>
                <h1>Please Create the Burger First....</h1>
                <h3 style={{
                        fontFamily: 'cursive',
                        opacity: '0.6',
                        fontSize: 'x-large'
                }}>You have nothing to checkout...</h3>
                <div>
                    <img src={NoRecord} alt="no record" width="100%"/>
                </div>
            </div>
        return(
            <div className={classes.AlignCheckout}>
                {isIngredientsAvailable}
                <Route path={this.props.match.path + '/contactData'} 
                render={() => {
                   return Object.values(this.props.ingredients).reduce((current , sum) => {
                       return sum + current;
                   } , 0) > 0 ?
                    <ContactData ingredients={this.props.ingredients} token={this.props.token}/> :
                    null;
                }
                }/>
            </div>
        );
    }
}

const linkGlobalStore = (state) => {
    return {
        ...state.Reducer,
        ...state.AuthReducer
    }
}

export default connect(linkGlobalStore)(Checkout);